module.exports = __webpack_public_path__ + "static/img/problemDetails.b9d7181.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buyersShow/problemDetails.png
// module id = Okba
// module chunks = 1